import { User, UserTypeAll } from '../types';

export const showToRoles = (
  roles: Array<UserTypeAll> | 'admin' | 'client',
  user: User,
): boolean => {
  const myRole = user.type;

  if (!roles) return false;

  if (roles === 'admin')
    return [
      'SUPER_ADMIN',
      'YARD_COMPANY_ADMIN',
      'YARD_COMPANY_EMPLOYEE',
      'YARD_MANAGER',
      'YARD_DISPATCHER',
      'YARD_CRANE_OPERATOR',
    ].some((role) => myRole === role);

  if (roles === 'client')
    return ['CLIENT_MANAGER', 'CLIENT_DISPATCHER'].some((role) => myRole === role);

  return roles.some((role) => myRole === role);
};
